<section>
  <div *ngIf="!readOnly">
    <p [innerHTML]="'$evaluation_exec_summary_introduction' | translate"></p>
    <editor apiKey="{{tinyApiKey}}"
            cloudChannel="dev"
            [init]="mceConfig"
            [initialValue]="initialValue"
            (onFocusOut)="onEditorChange($event, question.id, question.answers[0])"
            (onChange)="onEditorChange($event, question.id, question.answers[0])"></editor>
  </div>

  <div *ngIf="readOnly">
    <!-- <p  *ngIf="initialValue"><span [innerHTML]="'$evaluation_exec_summary_section_heading' | translate"></span>:</p> -->
    <span *ngIf="initialValue" [innerHTML]="initialValue | safeHtml"></span>
    <span *ngIf="!initialValue" [innerHTML]="'$evaluation_exec_summary_no_summary' | translate"></span>
  </div>
</section>